import { useMemo } from 'react';

import { TabTableContainer } from 'components/layout/AppLayout/AppLayout.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { PAYMENT } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

/**
 * @author Burak Ak
 */
const SubscriptionTransactionList = () => {
	const defaultSort = useMemo(() => [{ id: 'ID', desc: true }], []);

	const columns = useMemo(
		() => [
			{ Header: 'ID', accessor: 'ID', filterType: FilterType.number, width: 50, show: false },
			{
				Header: 'date',
				accessor: 'transactionDate',
				filterType: FilterType.date,
				width: 70,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'plan',
				accessor: 'packageName',
				filterType: FilterType.string,
				showOnMobile: true,
				width: 80,
				translate: true
			},
			{
				Header: 'description',
				accessor: 'description',
				filterType: FilterType.string,
				width: 100,
				show: false
			},
			{
				Header: 'servicePeriodStart',
				accessor: 'servicePeriodStart',
				filterType: FilterType.date,
				width: 80,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'servicePeriodEnd',
				accessor: 'servicePeriodEnd',
				filterType: FilterType.date,
				width: 80,
				renderCell: ListComponents.DATETIME
			},
			{
				Header: 'paymentMethod',
				accessor: 'cardLastFour',
				filterType: FilterType.string,
				width: 150,
				renderCell: ListComponents.CARD
			},
			{
				Header: 'amountWithoutTax',
				accessor: 'amountWithoutTax',
				filterType: FilterType.float,
				width: 60,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'totalAmount',
				accessor: 'amount',
				filterType: FilterType.float,
				width: 60,
				renderCell: ListComponents.CURRENCY
			},
			{
				Header: 'promoCodeTitle',
				accessor: 'promoCode',
				filterType: FilterType.string
			},
			{
				Header: 'invoiceLink',
				accessor: 'invoiceLink',
				width: 80,
				filterType: FilterType.multiSelection,
				renderCell: ListComponents.DOWNLOAD_INVOICE,
				showOnMobile: true
			},
			{
				Header: 'refundStatus',
				accessor: 'refundStatus',
				filterType: FilterType.multiSelection,
				width: 100,
				renderCell: ListComponents.STATUS
			},
			{
				Header: 'status',
				accessor: 'status',
				filterType: FilterType.multiSelection,
				width: 100,
				renderCell: ListComponents.STATUS,
				showOnMobile: true
			}
		],
		[]
	);

	return (
		<TabTableContainer>
			<DynamicList
				id={DYNAMICLISTS.SUBSCRIPTION_TRANSACTIONS}
				columns={columns}
				fetchUrl={PAYMENT.GET_SUBSCRIPTION_PAYMENT_LIST}
				defaultSort={defaultSort}
				exportName="subscriptionTransactionList"
			/>
		</TabTableContainer>
	);
};

export default SubscriptionTransactionList;
